import * as yup from 'yup';

export const flashDealsValidationSchema = yup.object({
  dealType: yup.number().required('Deal type is required'),
  
  fromSource: yup.string().required('From location is required').trim(),
  
  toDestination: yup.string().required('To location is required').trim(),
  
  pickupAddress: yup.string().required('Pickup address is required').trim().max(30, 'Pickup address cannot exceed 30 characters'),
  
  carType: yup.object().shape({
    id: yup.number().required('Car type is required').min(1, 'Please select a car type')
  }),
  
  pickupStartDatetime: yup.date().nullable().required('Pickup start time is required'),
  
  pickupEndDatetime: yup.date()
    .nullable()
    .required('Pickup end time is required')
    .test('is-after-start', 'Pickup end time must be after start time', function(value) {
      const { pickupStartDatetime } = this.parent;
      if (!value || !pickupStartDatetime) return true;
      return value > pickupStartDatetime;
    }),
  
  dealStartDatetime: yup.date().nullable().required('Deal start date is required'),
  
  dealEndDatetime: yup.date()
    .nullable()
    .required('Deal end date is required')
    .test('is-after-start', 'Deal end date must be after start date', function(value) {
      const { dealStartDatetime } = this.parent;
      if (!value || !dealStartDatetime) return true;
      return value > dealStartDatetime;
    }),
  
    basePrice: yup.number()
  .nullable()
  .when('dealType', {
    is: 1, // One Way
    then: (schema) =>
      schema.required('Base price is required for One Way deals')
            .min(0, 'Base price must be positive'),
    otherwise: (schema) =>
      schema.nullable() // Not required for Shared Trip (dealType 2)
  }),

offerPrice: yup.number()
  .nullable()
  .when('dealType', {
    is: 1, // One Way
    then: (schema) =>
      schema.required('Offer price is required for One Way deals')
            .min(0, 'Offer price must be positive')
            .test('less-than-base', 'Offer price must be less than base price', function(value) {
              const { basePrice } = this.parent;
              if (!value || !basePrice) return true;
              return value < basePrice;
            }),
    otherwise: (schema) =>
      schema.nullable() // Not required for Shared Trip (dealType 2)
  }),

  // basePrice: yup.number()
  //   .nullable()
  //   .required('Base price is required')
  //   .min(0, 'Base price must be positive'),
  
  // offerPrice: yup.number()
  //   .nullable()
  //   .required('Offer price is required')
  //   .min(0, 'Offer price must be positive')
  //   .test('less-than-base', 'Offer price must be less than base price', function(value) {
  //     const { basePrice } = this.parent;
  //     if (!value || !basePrice) return true;
  //     return value < basePrice;
  //   }),
  
  availableSeats: yup.number()
    .nullable()
    .min(1, 'Available seats must be at least 1')
    .max(6, 'Available seats cannot exceed 10')
    .when('dealType', {
      is: 2, // Shared Trip
      then: (schema) => schema.required('Available seats is required for shared trips'),
      otherwise: (schema) => schema.nullable()
    }),
  
  linkedTripCode: yup.string().trim(),
  
  isActive: yup.boolean()
});
